/* eslint-disable no-template-curly-in-string */
import { Page } from 'componentregistry';

export default {
  '01gav0qpssa9jrk0gz6w29sqfg': {
    children: [],
    itemId: '01gav0qpssa9jrk0gz6w29sqfg',
    parent: 'actionCreate1',
    props: {
      attribute: 'actionType',
      value: {
        type: 'expression',
        value: '$.$pageData.formatType',
      },
    },
    type: 'ActionSet',
  },
  '01h0ftdxf1n3vpfkz16rxxadrh': {
    children: [],
    itemId: '01h0ftdxf1n3vpfkz16rxxadrh',
    parent: 'messageBox',
    props: {
      text: {
        type: 'expression',
        value: '$.$pageData.message',
      },
    },
    type: 'Typography',
  },
  '01h0fte4s6bqc6e7emrb9gr4vx': {
    children: [],
    itemId: '01h0fte4s6bqc6e7emrb9gr4vx',
    parent: 'messageBox',
    props: {
      color: {
        type: 'text',
        value: 'rgba(65,117,5,1)',
      },
      icon: {
        iconName: 'exclamation-circle',
        iconType: 'light',
      },
    },
    type: 'Icon',
  },
  '01h0fwckaawr22x3tfgq6wtzjg': {
    children: ['01h0fwysccn3n2d1yrhnkd278y'],
    itemId: '01h0fwckaawr22x3tfgq6wtzjg',
    parent: 'flexPanel',
    props: {
      max: 40,
      min: 40,
      sizeType: 'minmax',
    },
    type: 'FlexItem',
  },
  '01h0fwnardt3bh7d3j3gvhbrps': {
    children: [],
    itemId: '01h0fwnardt3bh7d3j3gvhbrps',
    parent: '01h0fwysccn3n2d1yrhnkd278y',
    props: {
      alias: 'ioAsyncExportsAlias',
      shape: 'rounded',
    },
    type: 'Pagination',
  },
  '01h0fwysccn3n2d1yrhnkd278y': {
    children: ['01h0fwnardt3bh7d3j3gvhbrps'],
    itemId: '01h0fwysccn3n2d1yrhnkd278y',
    parent: '01h0fwckaawr22x3tfgq6wtzjg',
    props: {},
    type: 'Box',
  },
  '01h0q1t2p0mzcyxyt2rvx443qm': {
    children: ['01h0q1t7veyh9xkzp75n3m3yy2'],
    itemId: '01h0q1t2p0mzcyxyt2rvx443qm',
    parent: 'flexItem4',
    props: {},
    type: 'Box',
  },
  '01h0q1t7veyh9xkzp75n3m3yy2': {
    children: [],
    itemId: '01h0q1t7veyh9xkzp75n3m3yy2',
    parent: '01h0q1t2p0mzcyxyt2rvx443qm',
    props: {
      text: {
        type: 'text',
        value: null,
      },
      viewAttribute: 'exportContext',
    },
    type: 'HTML',
  },
  '01h110q4y9ej2vaf4r73g1g6e5': {
    children: [],
    itemId: '01h110q4y9ej2vaf4r73g1g6e5',
    parent: 'triggerOnClick3',
    props: {
      alias: 'ioAsyncExportsAlias',
    },
    type: 'ActionRefresh',
  },
  '01h1126z4ebh3345a0edmjj8q2': {
    children: [],
    itemId: '01h1126z4ebh3345a0edmjj8q2',
    parent: '01h1126z4ep5kkepfzh7feep2g',
    props: {
      attribute: 'itemId',
      disableCondition: '!!$.$pageData.itemId',
      operator: 'is',
      value: [
        {
          type: 'expression',
          value: '$.$pageData.itemId',
        },
      ],
    },
    type: 'ActionSetQueryFilter',
  },
  '01h1126z4ep5kkepfzh7feep2g': {
    children: [
      '01h113dvdbcv9t00800csyesbr',
      '01h1126z4ebh3345a0edmjj8q2',
      '01h1128gj5xsc51bs2ftr2m065',
      '01h11291pn35pv47ph2wvyre96',
    ],
    itemId: '01h1126z4ep5kkepfzh7feep2g',
    parent: 'dataStore',
    props: {},
    type: 'TriggerBeforeQuery',
  },
  '01h1128gj5xsc51bs2ftr2m065': {
    children: [],
    itemId: '01h1128gj5xsc51bs2ftr2m065',
    parent: '01h1126z4ep5kkepfzh7feep2g',
    props: {
      attribute: 'pageCode',
      disableCondition: '!!$.$pageData.pageCode',
      operator: 'is',
      value: [
        {
          type: 'expression',
          value: '$.$pageData.pageCode',
        },
      ],
    },
    type: 'ActionSetQueryFilter',
  },
  '01h11291pn35pv47ph2wvyre96': {
    children: [],
    itemId: '01h11291pn35pv47ph2wvyre96',
    parent: '01h1126z4ep5kkepfzh7feep2g',
    props: {
      attribute: 'datasourceUid',
      disableCondition: '!!$.$pageData.datasourceUid',
      operator: 'is',
      value: [
        {
          type: 'expression',
          value: '$.$pageData.datasourceUid',
        },
      ],
    },
    type: 'ActionSetQueryFilter',
  },
  '01h113dvdbcv9t00800csyesbr': {
    children: [],
    itemId: '01h113dvdbcv9t00800csyesbr',
    parent: '01h1126z4ep5kkepfzh7feep2g',
    props: {
      attributeCode: 'lastUpdateDate',
      sortOrder: 'DESC',
    },
    type: 'ActionSetSort',
  },
  '01h148wv68wvwvhhd307jc63r2': {
    children: [],
    itemId: '01h148wv68wvwvhhd307jc63r2',
    parent: 'dataGrid',
    props: {
      label: 'Name',
      viewAttribute: 'exportName',
      width: 180,
    },
    type: 'StringColumn',
  },
  '01h148yfztk0hzdvsww1v6tac3': {
    children: ['01h148yqmzwvkjrsmn12zwfjkh', '01h148ysrjq2z1hn6pjkqk1cs8'],
    itemId: '01h148yfztk0hzdvsww1v6tac3',
    parent: 'dataGrid',
    props: {
      expression: {
        type: 'expression',
        value: '!!$.ioAsyncExportsAlias.scheduleDate',
      },
      label: '',
      width: 20,
    },
    type: 'SwitchColumn',
  },
  '01h148yqmzwvkjrsmn12zwfjkh': {
    children: ['01h148z3k8mhvbnhgr10j3dp78'],
    itemId: '01h148yqmzwvkjrsmn12zwfjkh',
    parent: '01h148yfztk0hzdvsww1v6tac3',
    props: {
      case: 'true',
    },
    type: 'SwitchColumnCase',
  },
  '01h148ysrjq2z1hn6pjkqk1cs8': {
    children: ['01h14932shrb00t9cgttct2r6e'],
    itemId: '01h148ysrjq2z1hn6pjkqk1cs8',
    parent: '01h148yfztk0hzdvsww1v6tac3',
    props: {
      case: 'false',
    },
    type: 'SwitchColumnCase',
  },
  '01h148z3k8mhvbnhgr10j3dp78': {
    children: [],
    itemId: '01h148z3k8mhvbnhgr10j3dp78',
    parent: '01h148yqmzwvkjrsmn12zwfjkh',
    props: {
      color: 'warning',
      icon: {
        iconName: 'calendar-clock',
        iconType: 'regular',
      },
      label: '',
      toolTip: {
        type: 'expression',
        value:
          "'Scheduled at '+ format($.ioAsyncExportsAlias.scheduleDate, 'dd/MM/yy hh:mm:ss a')",
      },
    },
    type: 'IconColumn',
  },
  '01h14932shrb00t9cgttct2r6e': {
    children: [],
    itemId: '01h14932shrb00t9cgttct2r6e',
    parent: '01h148ysrjq2z1hn6pjkqk1cs8',
    props: {
      icon: {
        iconName: 'calendar-day',
        iconType: 'regular',
      },
      label: '',
      toolTip: {
        type: 'expression',
        value:
          "'Scheduled at '+ format($.ioAsyncExportsAlias.creationDate, 'dd/MM/yy hh:mm:ss a')",
      },
    },
    type: 'IconColumn',
  },
  '01h1499f38rb3wcz7q1pc19bgb': {
    children: [],
    itemId: '01h1499f38rb3wcz7q1pc19bgb',
    parent: 'dataGrid',
    props: {
      alignment: 'center',
      label: 'Requester',
      size: 32,
      viewAttribute: 'createdBy',
      width: 80,
    },
    type: 'UserPicColumn',
  },
  '01h149c32t4cnbr7cgvaat5z3t': {
    children: ['01h149c32tqjs6e6mbabk7f5wc'],
    itemId: '01h149c32t4cnbr7cgvaat5z3t',
    parent: '01h149c32txtzk40af1t2nqac8',
    props: {
      case: 'XLSX',
    },
    type: 'SwitchColumnCase',
  },
  '01h149c32t5jpjrs9dzsqs4m3e': {
    children: [],
    itemId: '01h149c32t5jpjrs9dzsqs4m3e',
    parent: '01h149c32tm7e79j6vkd81q0f3',
    props: {
      icon: {
        iconName: 'file-csv',
        iconType: 'regular',
      },
      label: '',
      size: 'medium',
      toolTip: {
        type: 'text',
        value: 'CSV',
      },
    },
    type: 'IconColumn',
  },
  '01h149c32tm7e79j6vkd81q0f3': {
    children: ['01h149c32t5jpjrs9dzsqs4m3e'],
    itemId: '01h149c32tm7e79j6vkd81q0f3',
    parent: '01h149c32txtzk40af1t2nqac8',
    props: {
      case: 'CSV',
    },
    type: 'SwitchColumnCase',
  },
  '01h149c32tqjs6e6mbabk7f5wc': {
    children: [],
    itemId: '01h149c32tqjs6e6mbabk7f5wc',
    parent: '01h149c32t4cnbr7cgvaat5z3t',
    props: {
      icon: {
        iconName: 'file-excel',
        iconType: 'regular',
      },
      label: '',
      size: 'medium',
      toolTip: {
        type: 'text',
        value: 'Excel',
      },
    },
    type: 'IconColumn',
  },
  '01h149c32txtzk40af1t2nqac8': {
    children: ['01h149c32t4cnbr7cgvaat5z3t', '01h149c32tm7e79j6vkd81q0f3'],
    itemId: '01h149c32txtzk40af1t2nqac8',
    parent: 'dataGrid',
    props: {
      expression: {
        type: 'expression',
        value: '$.ioAsyncExportsAlias.actionType',
      },
      label: 'Type',
      width: 50,
    },
    type: 'SwitchColumn',
  },
  '01h149mv0x495wqgxfyvq5tb3f': {
    children: [
      '01h149mv0xe8mva08js2qt7zvy',
      '01h149mv0x574pf7gc9mzgdxgd',
      '01h149mzm01t14ywxz8fr8fpj1',
      '01h149n1qkbh54z9zxmqzyh1sy',
    ],
    itemId: '01h149mv0x495wqgxfyvq5tb3f',
    parent: 'dataGrid',
    props: {
      expression: {
        type: 'expression',
        value: '$.ioAsyncExportsAlias.status',
      },
      label: 'Status',
      width: 50,
    },
    type: 'SwitchColumn',
  },
  '01h149mv0x574pf7gc9mzgdxgd': {
    children: ['01h149mv0xef2ht77fw4e60kff'],
    itemId: '01h149mv0x574pf7gc9mzgdxgd',
    parent: '01h149mv0x495wqgxfyvq5tb3f',
    props: {
      case: 'R',
    },
    type: 'SwitchColumnCase',
  },
  '01h149mv0xe8mva08js2qt7zvy': {
    children: ['01h149mv0xnh3y7z75crfyhk4a'],
    itemId: '01h149mv0xe8mva08js2qt7zvy',
    parent: '01h149mv0x495wqgxfyvq5tb3f',
    props: {
      case: 'S',
    },
    type: 'SwitchColumnCase',
  },
  '01h149mv0xef2ht77fw4e60kff': {
    children: [],
    itemId: '01h149mv0xef2ht77fw4e60kff',
    parent: '01h149mv0x574pf7gc9mzgdxgd',
    props: {
      icon: {
        iconName: 'running',
        iconType: 'regular',
      },
      label: '',
      size: 'medium',
      toolTip: {
        type: 'text',
        value: 'Running',
      },
    },
    type: 'IconColumn',
  },
  '01h149mv0xnh3y7z75crfyhk4a': {
    children: [],
    itemId: '01h149mv0xnh3y7z75crfyhk4a',
    parent: '01h149mv0xe8mva08js2qt7zvy',
    props: {
      color: 'success',
      icon: {
        iconName: 'badge-check',
        iconType: 'regular',
      },
      label: '',
      size: 'medium',
      toolTip: {
        type: 'text',
        value: 'Success',
      },
    },
    type: 'IconColumn',
  },
  '01h149mzm01t14ywxz8fr8fpj1': {
    children: ['01h149mzm0bp57r3sd2e9frz70'],
    itemId: '01h149mzm01t14ywxz8fr8fpj1',
    parent: '01h149mv0x495wqgxfyvq5tb3f',
    props: {
      case: 'P',
    },
    type: 'SwitchColumnCase',
  },
  '01h149mzm0bp57r3sd2e9frz70': {
    children: [],
    itemId: '01h149mzm0bp57r3sd2e9frz70',
    parent: '01h149mzm01t14ywxz8fr8fpj1',
    props: {
      color: 'warning',
      icon: {
        iconName: 'calendar-clock',
        iconType: 'regular',
      },
      label: '',
      size: 'medium',
      toolTip: {
        type: 'text',
        value: 'Scheduled',
      },
    },
    type: 'IconColumn',
  },
  '01h149n1qk5b0fjcsmbbvsqcjc': {
    children: [],
    itemId: '01h149n1qk5b0fjcsmbbvsqcjc',
    parent: '01h149n1qkbh54z9zxmqzyh1sy',
    props: {
      color: 'error',
      icon: {
        iconName: 'seal-exclamation',
        iconType: 'regular',
      },
      label: '',
      size: 'medium',
      toolTip: {
        type: 'text',
        value: 'Errored',
      },
    },
    type: 'IconColumn',
  },
  '01h149n1qkbh54z9zxmqzyh1sy': {
    children: ['01h149n1qk5b0fjcsmbbvsqcjc'],
    itemId: '01h149n1qkbh54z9zxmqzyh1sy',
    parent: '01h149mv0x495wqgxfyvq5tb3f',
    props: {
      case: 'E',
    },
    type: 'SwitchColumnCase',
  },
  '01h149wh5m98h9ky32zj9qf85x': {
    children: ['01h149xa20bjvsjzthnspmb3g5'],
    itemId: '01h149wh5m98h9ky32zj9qf85x',
    parent: 'dataGrid',
    props: {
      label: 'Download File',
      viewAttribute: 'fileName',
      width: 260,
    },
    type: 'StringColumn',
  },
  '01h149xa20bjvsjzthnspmb3g5': {
    children: ['01h149xfrjyqmpkkwntpmb0hqm'],
    itemId: '01h149xa20bjvsjzthnspmb3g5',
    parent: '01h149wh5m98h9ky32zj9qf85x',
    props: {
      disableCondition: '!!$.ioAsyncExportsAlias.fileUid',
    },
    type: 'TriggerOnCellClick',
  },
  '01h149xfrjyqmpkkwntpmb0hqm': {
    children: [],
    itemId: '01h149xfrjyqmpkkwntpmb0hqm',
    parent: '01h149xa20bjvsjzthnspmb3g5',
    props: {
      attachmentId: {
        type: 'expression',
        value: '$.ioAsyncExportsAlias.fileUid',
      },
    },
    type: 'ActionDownloadAttachment',
  },
  '01h149ysv8ngjd20k9b67z8tt2': {
    children: ['01h14a036x88f6h641ssvbqcxm'],
    itemId: '01h149ysv8ngjd20k9b67z8tt2',
    parent: 'dataGrid',
    props: {
      icon: {
        iconName: 'file-circle-info',
        iconType: 'regular',
      },
      label: 'Context',
      size: 'medium',
      width: 60,
    },
    type: 'IconColumn',
  },
  '01h14a036x88f6h641ssvbqcxm': {
    children: ['01h14a0bq36xra15xe1sd0vgcq'],
    itemId: '01h14a036x88f6h641ssvbqcxm',
    parent: '01h149ysv8ngjd20k9b67z8tt2',
    props: {},
    type: 'TriggerOnClick',
  },
  '01h14a0bq36xra15xe1sd0vgcq': {
    children: [],
    itemId: '01h14a0bq36xra15xe1sd0vgcq',
    parent: '01h14a036x88f6h641ssvbqcxm',
    props: {
      targetItemId: 'exportContext',
    },
    type: 'ActionOpenPopup',
  },
  '01h14a0j7afadrxy77qxqj32tm': {
    children: ['01h14a0j7ageaxkrg3v1zj0kdx'],
    itemId: '01h14a0j7afadrxy77qxqj32tm',
    parent: 'dataGrid',
    props: {
      icon: {
        iconName: 'file-circle-check',
        iconType: 'regular',
      },
      label: 'Request',
      size: 'medium',
      width: 60,
    },
    type: 'IconColumn',
  },
  '01h14a0j7ageaxkrg3v1zj0kdx': {
    children: ['01h14a16dnfv423zkdw9hsqr2r'],
    itemId: '01h14a0j7ageaxkrg3v1zj0kdx',
    parent: '01h14a0j7afadrxy77qxqj32tm',
    props: {},
    type: 'TriggerOnClick',
  },
  '01h14a16dnfv423zkdw9hsqr2r': {
    children: [],
    itemId: '01h14a16dnfv423zkdw9hsqr2r',
    parent: '01h14a0j7ageaxkrg3v1zj0kdx',
    props: {
      targetItemId: 'requestPopup',
    },
    type: 'ActionOpenPopup',
  },
  '01h14afse4yjktp3jfzf091a3j': {
    children: [],
    itemId: '01h14afse4yjktp3jfzf091a3j',
    parent: 'triggerOnPopupClose',
    props: {
      alias: 'ioAsyncExportsAlias',
      disableCondition: '$.ioAsyncExportsAlias.$dirty',
    },
    type: 'ActionReset',
  },
  actionClosePopup: {
    children: [],
    itemId: 'actionClosePopup',
    parent: 'triggerOnClick3',
    props: {
      targetItemId: 'scheduleAtPopup',
    },
    type: 'ActionClosePopup',
  },
  actionCreate: {
    children: [
      'actionSet1',
      'actionSet4',
      'actionSet5',
      'actionSet6',
      'actionSet7',
      'actionSet14',
      'actionSet16',
    ],
    itemId: 'actionCreate',
    parent: 'triggerOnClick',
    props: {
      alias: 'ioAsyncExportsAlias',
      markAsDirty: true,
    },
    type: 'ActionCreate',
  },
  actionCreate1: {
    children: [
      'actionSet11',
      'actionSet9',
      'actionSet10',
      'actionSet13',
      'actionSet12',
      'actionSet8',
      'actionSet15',
      '01gav0qpssa9jrk0gz6w29sqfg',
    ],
    itemId: 'actionCreate1',
    parent: 'triggerOnClick1',
    props: {
      alias: 'ioAsyncExportsAlias',
      markAsDirty: true,
    },
    type: 'ActionCreate',
  },
  actionDeleteSelectedRecords: {
    children: [],
    itemId: 'actionDeleteSelectedRecords',
    parent: 'triggerOnClick5',
    props: {
      alias: 'ioAsyncExportsAlias',
      confirmationMessage: {
        type: 'text',
        value: 'Are you sure you want to delete these exports?',
      },
    },
    type: 'ActionDeleteSelectedRecords',
  },
  actionDeselectAll: {
    children: [],
    itemId: 'actionDeselectAll',
    parent: 'triggerOnClick2',
    props: {
      alias: 'ioAsyncExportsAlias',
    },
    type: 'ActionDeselectAll',
  },
  actionDeselectAll1: {
    children: [],
    itemId: 'actionDeselectAll1',
    parent: 'triggerOnClick6',
    props: {
      alias: 'ioAsyncExportsAlias',
    },
    type: 'ActionDeselectAll',
  },
  actionHide: {
    children: [],
    itemId: 'actionHide',
    parent: 'triggerOnClick2',
    props: {
      targetItemId: 'messageBox',
    },
    type: 'ActionHide',
  },
  actionHide1: {
    children: [],
    itemId: 'actionHide1',
    parent: 'triggerOnClick5',
    props: {
      targetItemId: 'messageBox',
    },
    type: 'ActionHide',
  },
  actionHide2: {
    children: [],
    itemId: 'actionHide2',
    parent: 'triggerOnClick6',
    props: {
      targetItemId: 'messageBox',
    },
    type: 'ActionHide',
  },
  actionLoopRecords: {
    children: ['actionSet2'],
    itemId: 'actionLoopRecords',
    parent: 'triggerOnClick2',
    props: {
      alias: 'ioAsyncExportsAlias',
      loop: 'selected',
    },
    type: 'ActionLoopRecords',
  },
  actionLoopRecords1: {
    children: ['actionSet3'],
    itemId: 'actionLoopRecords1',
    parent: 'triggerOnClick6',
    props: {
      alias: 'ioAsyncExportsAlias',
      loop: 'selected',
    },
    type: 'ActionLoopRecords',
  },
  actionOpenPopup: {
    children: [],
    itemId: 'actionOpenPopup',
    parent: 'triggerOnClick1',
    props: {
      targetItemId: 'scheduleAtPopup',
    },
    type: 'ActionOpenPopup',
  },
  actionOpenPopup1: {
    children: [],
    itemId: 'actionOpenPopup1',
    parent: 'triggerOnClick',
    props: {
      targetItemId: 'scheduleAtPopup',
    },
    type: 'ActionOpenPopup',
  },
  actionRefresh: {
    children: [],
    itemId: 'actionRefresh',
    parent: 'triggerOnClick4',
    props: {
      alias: 'ioAsyncExportsAlias',
    },
    type: 'ActionRefresh',
  },
  actionSave: {
    children: [],
    itemId: 'actionSave',
    parent: 'triggerOnClick5',
    props: {
      alias: 'ioAsyncExportsAlias',
      silent: true,
    },
    type: 'ActionSave',
  },
  actionSave1: {
    children: [],
    itemId: 'actionSave1',
    parent: 'triggerOnClick2',
    props: {
      alias: 'ioAsyncExportsAlias',
      silent: true,
    },
    type: 'ActionSave',
  },
  actionSave2: {
    children: [],
    itemId: 'actionSave2',
    parent: 'triggerOnClick6',
    props: {
      alias: 'ioAsyncExportsAlias',
      silent: true,
    },
    type: 'ActionSave',
  },
  actionSave3: {
    children: [],
    itemId: 'actionSave3',
    parent: 'triggerOnClick3',
    props: {
      alias: 'ioAsyncExportsAlias',
      silent: true,
    },
    type: 'ActionSave',
  },
  actionSet1: {
    children: [],
    itemId: 'actionSet1',
    parent: 'actionCreate',
    props: {
      attribute: 'status',
      value: {
        type: 'text',
        value: 'P',
      },
    },
    type: 'ActionSet',
  },
  actionSet10: {
    children: [],
    itemId: 'actionSet10',
    parent: 'actionCreate1',
    props: {
      attribute: 'itemId',
      value: {
        type: 'expression',
        value: '$.$pageData.itemId',
      },
    },
    type: 'ActionSet',
  },
  actionSet11: {
    children: [],
    itemId: 'actionSet11',
    parent: 'actionCreate1',
    props: {
      attribute: 'status',
      value: {
        type: 'text',
        value: 'P',
      },
    },
    type: 'ActionSet',
  },
  actionSet12: {
    children: [],
    itemId: 'actionSet12',
    parent: 'actionCreate1',
    props: {
      attribute: 'datasourceUid',
      value: {
        type: 'expression',
        value: '$.$pageData.datasourceUid',
      },
    },
    type: 'ActionSet',
  },
  actionSet13: {
    children: [],
    itemId: 'actionSet13',
    parent: 'actionCreate1',
    props: {
      attribute: 'pageCode',
      value: {
        type: 'expression',
        value: '$.$pageData.pageCode',
      },
    },
    type: 'ActionSet',
  },
  actionSet14: {
    children: [],
    itemId: 'actionSet14',
    parent: 'actionCreate',
    props: {
      attribute: 'requestJson',
      value: {
        type: 'expression',
        value: '$.$pageData.requestJson',
      },
    },
    type: 'ActionSet',
  },
  actionSet15: {
    children: [],
    itemId: 'actionSet15',
    parent: 'actionCreate1',
    props: {
      attribute: 'requestJson',
      value: {
        type: 'expression',
        value: '$.$pageData.requestJson',
      },
    },
    type: 'ActionSet',
  },
  actionSet16: {
    children: [],
    itemId: 'actionSet16',
    parent: 'actionCreate',
    props: {
      attribute: 'actionType',
      value: {
        type: 'expression',
        value: '$.$pageData.formatType',
      },
    },
    type: 'ActionSet',
  },
  actionSet2: {
    children: [],
    itemId: 'actionSet2',
    parent: 'actionLoopRecords',
    props: {
      attribute: 'status',
      value: {
        type: 'text',
        value: 'C',
      },
    },
    type: 'ActionSet',
  },
  actionSet3: {
    children: [],
    itemId: 'actionSet3',
    parent: 'actionLoopRecords1',
    props: {
      attribute: 'status',
      value: {
        type: 'text',
        value: 'P',
      },
    },
    type: 'ActionSet',
  },
  actionSet4: {
    children: [],
    itemId: 'actionSet4',
    parent: 'actionCreate',
    props: {
      attribute: 'itemId',
      value: {
        type: 'expression',
        value: '$.$pageData.itemId',
      },
    },
    type: 'ActionSet',
  },
  actionSet5: {
    children: [],
    itemId: 'actionSet5',
    parent: 'actionCreate',
    props: {
      attribute: 'pageCode',
      value: {
        type: 'expression',
        value: '$.$pageData.pageCode',
      },
    },
    type: 'ActionSet',
  },
  actionSet6: {
    children: [],
    itemId: 'actionSet6',
    parent: 'actionCreate',
    props: {
      attribute: 'datasourceUid',
      value: {
        type: 'expression',
        value: '$.$pageData.datasourceUid',
      },
    },
    type: 'ActionSet',
  },
  actionSet7: {
    children: [],
    itemId: 'actionSet7',
    parent: 'actionCreate',
    props: {
      attribute: 'tzid',
      value: {
        type: 'expression',
        value: '$.$pageData.tzid',
      },
    },
    type: 'ActionSet',
  },
  actionSet8: {
    children: [],
    itemId: 'actionSet8',
    parent: 'actionCreate1',
    props: {
      attribute: 'tzid',
      value: {
        type: 'expression',
        value: '$.$pageData.tzid',
      },
    },
    type: 'ActionSet',
  },
  actionSet9: {
    children: [],
    itemId: 'actionSet9',
    parent: 'actionCreate1',
    props: {
      attribute: 'scheduleDate',
      value: {
        type: 'expression',
        value: '$.$pageData.scheduleDate',
      },
    },
    type: 'ActionSet',
  },
  actionSetData: {
    children: [],
    itemId: 'actionSetData',
    parent: 'triggerOnClick',
    props: {
      key: 'scheduleType',
      value: {
        type: 'text',
        value: 'NOW',
      },
    },
    type: 'ActionSetData',
  },
  actionSetData1: {
    children: [],
    itemId: 'actionSetData1',
    parent: 'triggerOnClick1',
    props: {
      key: 'scheduleType',
      value: {
        type: 'text',
        value: 'LATER',
      },
    },
    type: 'ActionSetData',
  },
  actionSetData2: {
    children: [],
    itemId: 'actionSetData2',
    parent: 'triggerOnClick5',
    props: {
      key: 'count',
      value: {
        type: 'expression',
        value: '$.ioAsyncExportsAlias.$selectedRowCount',
      },
    },
    type: 'ActionSetData',
  },
  actionSetData3: {
    children: [],
    itemId: 'actionSetData3',
    parent: 'triggerOnClick2',
    props: {
      key: 'message',
      value: {
        type: 'expression',
        value:
          '`Selected exports[${$.$pageData.count}] cancelled successfully!`',
      },
    },
    type: 'ActionSetData',
  },
  actionSetData4: {
    children: [],
    itemId: 'actionSetData4',
    parent: 'triggerOnClick5',
    props: {
      key: 'message',
      value: {
        type: 'expression',
        value: '`Selected exports[${$.$pageData.count}] deleted successfully!`',
      },
    },
    type: 'ActionSetData',
  },
  actionSetData5: {
    children: [],
    itemId: 'actionSetData5',
    parent: 'triggerOnClick6',
    props: {
      key: 'message',
      value: {
        type: 'expression',
        value:
          '`Selected exports[${$.$pageData.count}] set to reprocess successfully!`',
      },
    },
    type: 'ActionSetData',
  },
  actionSetData6: {
    children: [],
    itemId: 'actionSetData6',
    parent: 'triggerOnClick2',
    props: {
      key: 'count',
      value: {
        type: 'expression',
        value: '$.ioAsyncExportsAlias.$selectedRowCount',
      },
    },
    type: 'ActionSetData',
  },
  actionSetData7: {
    children: [],
    itemId: 'actionSetData7',
    parent: 'triggerOnClick6',
    props: {
      key: 'count',
      value: {
        type: 'expression',
        value: '$.ioAsyncExportsAlias.$selectedRowCount',
      },
    },
    type: 'ActionSetData',
  },
  actionShow: {
    children: [],
    itemId: 'actionShow',
    parent: 'triggerOnClick2',
    props: {
      targetItemId: 'messageBox',
    },
    type: 'ActionShow',
  },
  actionShow1: {
    children: [],
    itemId: 'actionShow1',
    parent: 'triggerOnClick5',
    props: {
      targetItemId: 'messageBox',
    },
    type: 'ActionShow',
  },
  actionShow2: {
    children: [],
    itemId: 'actionShow2',
    parent: 'triggerOnClick6',
    props: {
      targetItemId: 'messageBox',
    },
    type: 'ActionShow',
  },
  actionShowMessage: {
    children: [],
    itemId: 'actionShowMessage',
    parent: 'triggerOnClick3',
    props: {
      message: {
        type: 'text',
        value: 'Export scheduled successfully!',
      },
      type: 'success',
    },
    type: 'ActionShowMessage',
  },
  actionSleep: {
    children: [],
    itemId: 'actionSleep',
    parent: 'triggerOnClick2',
    props: {
      sleepTimeInMs: 2000,
    },
    type: 'ActionSleep',
  },
  actionSleep1: {
    children: [],
    itemId: 'actionSleep1',
    parent: 'triggerOnClick5',
    props: {
      sleepTimeInMs: 2000,
    },
    type: 'ActionSleep',
  },
  actionSleep2: {
    children: [],
    itemId: 'actionSleep2',
    parent: 'triggerOnClick6',
    props: {
      sleepTimeInMs: 2000,
    },
    type: 'ActionSleep',
  },
  box: {
    children: ['box1', 'box2'],
    itemId: 'box',
    parent: 'flexItem1',
    props: {
      border: {
        all: {
          borderColor: 'rgba(0, 0, 0, 0.12)',
          style: 'solid',
          width: 0,
        },
      },
      borderRadius: '8px',
      justifyContent: 'space-between',
      padding: {
        bottom: 8,
        left: 8,
        right: 8,
        top: 8,
      },
    },
    type: 'Box',
  },
  box1: {
    children: ['icon', 'typography', 'chip5'],
    itemId: 'box1',
    parent: 'box',
    props: {
      border: {
        all: {
          borderColor: 'rgba(0, 0, 0, 0.12)',
          style: 'solid',
          width: 0,
        },
      },
      gap: '8px',
    },
    type: 'Box',
  },
  box2: {
    children: [
      'messageBox',
      'button',
      'button1',
      'button2',
      'button3',
      'button4',
      'icon1',
    ],
    itemId: 'box2',
    parent: 'box',
    props: {
      gap: '8px',
    },
    type: 'Box',
  },
  box3: {
    children: ['button5'],
    itemId: 'box3',
    parent: 'flexItem2',
    props: {
      justifyContent: 'flex-end',
    },
    type: 'Box',
  },
  button: {
    children: ['triggerOnClick'],
    itemId: 'button',
    parent: 'box2',
    props: {
      size: 'small',
      startIcon: {
        iconName: 'calendar-day',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Schedule Now',
      },
      variant: 'outlined',
    },
    type: 'Button',
  },
  button1: {
    children: ['triggerOnClick1'],
    itemId: 'button1',
    parent: 'box2',
    props: {
      size: 'small',
      startIcon: {
        iconName: 'calendar-clock',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Schedule Later',
      },
      variant: 'outlined',
    },
    type: 'Button',
  },
  button2: {
    children: ['triggerOnClick2'],
    itemId: 'button2',
    parent: 'box2',
    props: {
      color: 'warning',
      disableCondition: '!$.ioAsyncExportsAlias.$selectedRowCount',
      size: 'small',
      startIcon: {
        iconName: 'times',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Cancel',
      },
      toolTip: {
        type: 'text',
        value: 'Cancel Selected',
      },
      variant: 'outlined',
      visible: false,
    },
    type: 'Button',
  },
  button3: {
    children: ['triggerOnClick5'],
    itemId: 'button3',
    parent: 'box2',
    props: {
      color: 'error',
      disableCondition: '!$.ioAsyncExportsAlias.$selectedRowCount',
      size: 'small',
      startIcon: {
        iconName: 'trash-alt',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Delete',
      },
      toolTip: {
        type: 'text',
        value: 'Delete Selected',
      },
      variant: 'outlined',
    },
    type: 'Button',
  },
  button4: {
    children: ['triggerOnClick6'],
    itemId: 'button4',
    parent: 'box2',
    props: {
      disableCondition: '!$.ioAsyncExportsAlias.$selectedRowCount',
      size: 'small',
      startIcon: {
        iconName: 'recycle',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Reprocess',
      },
      toolTip: {
        type: 'text',
        value: 'Reprocess Selected',
      },
      variant: 'outlined',
      visible: false,
    },
    type: 'Button',
  },
  button5: {
    children: ['triggerOnClick3'],
    itemId: 'button5',
    parent: 'box3',
    props: {
      disableCondition:
        '!$.ioAsyncExportsAlias.$dirty || isEmpty($.ioAsyncExportsAlias.exportName) || ($.$pageData.scheduleType === "LATER" && isEmpty($.ioAsyncExportsAlias.scheduleDate))',
      startIcon: {
        iconName: 'check',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Submit',
      },
    },
    type: 'Button',
  },
  chip5: {
    children: [],
    itemId: 'chip5',
    parent: 'box1',
    props: {
      color: 'default',
      label: {
        type: 'expression',
        value: '$.ioAsyncExportsAlias.$totalRowCount',
      },
      size: 'small',
      toolTip: {
        type: 'text',
        value: 'Total Count',
      },
    },
    type: 'Chip',
  },
  code: {
    children: [],
    itemId: 'code',
    parent: 'flexItem5',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      language: 'json',
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'requestJson',
    },
    type: 'Code',
  },
  dataGrid: {
    children: [
      'rowNumberColumn',
      'rowSelectionColumn',
      '01h148yfztk0hzdvsww1v6tac3',
      '01h148wv68wvwvhhd307jc63r2',
      '01h1499f38rb3wcz7q1pc19bgb',
      '01h149c32txtzk40af1t2nqac8',
      'stringColumn2',
      '01h149mv0x495wqgxfyvq5tb3f',
      '01h149wh5m98h9ky32zj9qf85x',
      'numberColumn',
      'dateColumn',
      'dateColumn2',
      '01h149ysv8ngjd20k9b67z8tt2',
      '01h14a0j7afadrxy77qxqj32tm',
    ],
    itemId: 'dataGrid',
    parent: 'flexItem',
    props: {
      headerBackgroundColor: {
        type: 'text',
        value: 'rgba(221,223,224,1)',
      },
      showColumnLines: false,
      showRowLines: false,
    },
    type: 'CanvasGrid',
  },
  dataStore: {
    children: ['01h1126z4ep5kkepfzh7feep2g'],
    itemId: 'dataStore',
    parent: 'root',
    props: {
      alias: 'ioAsyncExportsAlias',
      dataSource: 'IoAsyncExports',
      feedback: 'NONE',
      maxRows: 15,
      usePagination: true,
    },
    type: 'DataStore',
  },
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'ioAsyncExportsAlias',
    },
    type: 'DataStoreReference',
  },
  dataStoreReference1: {
    children: ['flexPanel1'],
    itemId: 'dataStoreReference1',
    parent: 'scheduleAtPopup',
    props: {
      alias: 'ioAsyncExportsAlias',
    },
    type: 'DataStoreReference',
  },
  dataStoreReference2: {
    children: ['flexPanel2'],
    itemId: 'dataStoreReference2',
    parent: 'exportContext',
    props: {
      alias: 'ioAsyncExportsAlias',
    },
    type: 'DataStoreReference',
  },
  dataStoreReference3: {
    children: ['flexPanel3'],
    itemId: 'dataStoreReference3',
    parent: 'requestPopup',
    props: {
      alias: 'ioAsyncExportsAlias',
    },
    type: 'DataStoreReference',
  },
  dateColumn: {
    children: [],
    itemId: 'dateColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: 'Created On',
      showTime: true,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'creationDate',
      width: 180,
    },
    type: 'DateColumn',
  },
  dateColumn2: {
    children: [],
    itemId: 'dateColumn2',
    parent: 'dataGrid',
    props: {
      label: 'Last Updated On',
      showTime: true,
      viewAttribute: 'lastUpdateDate',
      width: 170,
    },
    type: 'DateColumn',
  },
  dateField: {
    children: [],
    itemId: 'dateField',
    parent: 'form',
    props: {
      disablePast: true,
      flex: {
        xs: 12,
      },
      label: 'Select Date',
      required: true,
      showTime: true,
      viewAttribute: 'scheduleDate',
      visibleCondition: "$.$pageData.scheduleType === 'LATER'",
    },
    type: 'DateField',
  },
  exportContext: {
    children: ['dataStoreReference2'],
    itemId: 'exportContext',
    parent: 'folder',
    props: {
      popupWidth: 900,
      title: {
        type: 'expression',
        value: '`Export Context - ${$.ioAsyncExportsAlias.exportSchedulerUid}`',
      },
    },
    type: 'Popup',
  },
  flexItem: {
    children: ['dataGrid'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {
      border: {
        all: {
          style: 'solid',
          width: 0,
        },
      },
      max: 570,
      min: 570,
      padding: {
        bottom: 4,
        left: 4,
        right: 4,
        top: 4,
      },
      sizeType: 'minmax',
    },
    type: 'FlexItem',
  },
  flexItem1: {
    children: ['box'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {
      border: {
        bottom: {
          borderColor: {
            a: 1,
            b: 226,
            g: 144,
            r: 74,
          },
          style: 'solid',
          width: 2,
        },
        left: {
          style: 'solid',
          width: 0,
        },
        right: {
          style: 'solid',
          width: 0,
        },
        top: {
          style: 'solid',
          width: 0,
        },
      },
      padding: {
        all: 4,
      },
      sizeType: 'auto',
    },
    type: 'FlexItem',
  },
  flexItem2: {
    children: ['box3'],
    itemId: 'flexItem2',
    parent: 'flexPanel1',
    props: {
      sizeType: 'auto',
    },
    type: 'FlexItem',
  },
  flexItem3: {
    children: ['form'],
    itemId: 'flexItem3',
    parent: 'flexPanel1',
    props: {},
    type: 'FlexItem',
  },
  flexItem4: {
    children: ['01h0q1t2p0mzcyxyt2rvx443qm'],
    itemId: 'flexItem4',
    parent: 'flexPanel2',
    props: {
      overflow: 'scroll',
      padding: {
        bottom: 0,
        left: 12,
        right: 12,
        top: 0,
      },
    },
    type: 'FlexItem',
  },
  flexItem5: {
    children: ['code'],
    itemId: 'flexItem5',
    parent: 'flexPanel3',
    props: {
      overflow: 'scroll',
      padding: {
        all: 12,
      },
    },
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem1', 'flexItem', '01h0fwckaawr22x3tfgq6wtzjg'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {
      backgroundColor: 'paper',
    },
    type: 'FlexPanel',
  },
  flexPanel1: {
    children: ['flexItem3', 'flexItem2'],
    itemId: 'flexPanel1',
    parent: 'dataStoreReference1',
    props: {
      padding: {
        bottom: 0,
        left: 4,
        right: 16,
        top: 0,
      },
    },
    type: 'FlexPanel',
  },
  flexPanel2: {
    children: ['flexItem4'],
    itemId: 'flexPanel2',
    parent: 'dataStoreReference2',
    props: {},
    type: 'FlexPanel',
  },
  flexPanel3: {
    children: ['flexItem5'],
    itemId: 'flexPanel3',
    parent: 'dataStoreReference3',
    props: {},
    type: 'FlexPanel',
  },
  folder: {
    children: ['scheduleAtPopup', 'exportContext', 'requestPopup'],
    itemId: 'folder',
    parent: 'root',
    props: {
      icon: {
        iconName: 'window-restore',
      },
      name: 'Popups',
    },
    type: 'Folder',
  },
  form: {
    children: ['textField', 'dateField'],
    itemId: 'form',
    parent: 'flexItem3',
    props: {},
    type: 'Form',
  },
  icon: {
    children: [],
    itemId: 'icon',
    parent: 'box1',
    props: {
      color: {
        type: 'text',
        value: 'rgba(0,0,0,1)',
      },
      icon: {
        iconName: 'file-export',
        iconType: 'light',
      },
      size: 19,
    },
    type: 'Icon',
  },
  icon1: {
    children: ['triggerOnClick4'],
    itemId: 'icon1',
    parent: 'box2',
    props: {
      color: {
        type: 'text',
        value: 'rgba(74,144,226,1)',
      },
      icon: {
        iconName: 'redo-alt',
        iconType: 'regular',
      },
      size: 18,
      toolTip: {
        type: 'text',
        value: 'Refresh',
      },
    },
    type: 'Icon',
  },
  messageBox: {
    children: ['01h0fte4s6bqc6e7emrb9gr4vx', '01h0ftdxf1n3vpfkz16rxxadrh'],
    itemId: 'messageBox',
    parent: 'box2',
    props: {
      color: {
        type: 'text',
        value: 'rgba(65,117,5,1)',
      },
      gap: '4px',
      visible: false,
    },
    type: 'Box',
  },
  numberColumn: {
    children: [],
    itemId: 'numberColumn',
    parent: 'dataGrid',
    props: {
      allowDecimal: false,
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: 'File Size (in KB)',
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'fileSize',
      width: 100,
    },
    type: 'NumberColumn',
  },
  requestPopup: {
    children: ['dataStoreReference3'],
    itemId: 'requestPopup',
    parent: 'folder',
    props: {
      popupHeight: 800,
      title: {
        type: 'text',
        value: 'Request JSON',
      },
    },
    type: 'Popup',
  },
  root: {
    children: ['folder', 'dataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      backgroundColor: 'paper',
      padding: {
        all: 0,
      },
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  rowNumberColumn: {
    children: [],
    itemId: 'rowNumberColumn',
    parent: 'dataGrid',
    props: {
      label: '#',
    },
    type: 'RowNumberColumn',
  },
  rowSelectionColumn: {
    children: [],
    itemId: 'rowSelectionColumn',
    parent: 'dataGrid',
    props: {
      width: 40,
    },
    type: 'RowSelectionColumn',
  },
  scheduleAtPopup: {
    children: ['dataStoreReference1', 'triggerOnPopupClose'],
    itemId: 'scheduleAtPopup',
    parent: 'folder',
    props: {
      popupHeight: 280,
      popupWidth: 480,
      title: {
        type: 'expression',
        value: "$.$pageData.scheduleType === 'LATER' ? 'Schedule At' : ''",
      },
    },
    type: 'Popup',
  },
  stringColumn2: {
    children: [],
    itemId: 'stringColumn2',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: 'Client Timezone',
      maxLength: 60,
      required: true,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'tzid',
      width: 120,
    },
    type: 'StringColumn',
  },
  textField: {
    children: [],
    itemId: 'textField',
    parent: 'form',
    props: {
      autoFocus: true,
      flex: {
        xs: 12,
      },
      label: 'Name',
      maxLength: 128,
      required: true,
      viewAttribute: 'exportName',
    },
    type: 'TextField',
  },
  triggerOnClick: {
    children: ['actionSetData', 'actionOpenPopup1', 'actionCreate'],
    itemId: 'triggerOnClick',
    parent: 'button',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick1: {
    children: ['actionSetData1', 'actionCreate1', 'actionOpenPopup'],
    itemId: 'triggerOnClick1',
    parent: 'button1',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick2: {
    children: [
      'actionLoopRecords',
      'actionSetData6',
      'actionSave1',
      'actionDeselectAll',
      'actionSetData3',
      'actionShow',
      'actionSleep',
      'actionHide',
    ],
    itemId: 'triggerOnClick2',
    parent: 'button2',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick3: {
    children: [
      'actionSave3',
      'actionClosePopup',
      'actionShowMessage',
      '01h110q4y9ej2vaf4r73g1g6e5',
    ],
    itemId: 'triggerOnClick3',
    parent: 'button5',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick4: {
    children: ['actionRefresh'],
    itemId: 'triggerOnClick4',
    parent: 'icon1',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick5: {
    children: [
      'actionSetData2',
      'actionDeleteSelectedRecords',
      'actionSave',
      'actionSetData4',
      'actionShow1',
      'actionSleep1',
      'actionHide1',
    ],
    itemId: 'triggerOnClick5',
    parent: 'button3',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick6: {
    children: [
      'actionLoopRecords1',
      'actionSetData7',
      'actionSave2',
      'actionDeselectAll1',
      'actionSetData5',
      'actionShow2',
      'actionSleep2',
      'actionHide2',
    ],
    itemId: 'triggerOnClick6',
    parent: 'button4',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnPopupClose: {
    children: ['01h14afse4yjktp3jfzf091a3j'],
    itemId: 'triggerOnPopupClose',
    parent: 'scheduleAtPopup',
    props: {},
    type: 'TriggerOnPopupClose',
  },
  typography: {
    children: [],
    itemId: 'typography',
    parent: 'box1',
    props: {
      fontSize: '16px',
      fontWeight: 500,
      text: {
        type: 'text',
        value: 'Scheduled Exports',
      },
    },
    type: 'Typography',
  },
} as Page;
